export interface SkipErrorEmployeesParse {
  processErrors: boolean;
  remaining: string;
}

// Parses a free-text additional_options string (semicolon-separated KEY=VALUE).
// Extracts the SKIP_ERROR_EMPLOYEES token. processErrors === true ONLY when value is "False" (case-insensitive).
// remaining = the options string WITHOUT the SKIP_ERROR_EMPLOYEES token.
export function extractSkipErrorEmployees(raw: string | null | undefined): SkipErrorEmployeesParse {
  const parts = (raw || "").split(";").map((s) => s.trim()).filter(Boolean);
  const idx = parts.findIndex((p) => /^SKIP_ERROR_EMPLOYEES\s*=/i.test(p));
  if (idx === -1) return { processErrors: false, remaining: parts.join(";") };
  const value = parts[idx].split("=").slice(1).join("=").trim();
  const processErrors = value.toLowerCase() === "false";
  const remaining = parts.filter((_, i) => i !== idx).join(";");
  return { processErrors, remaining };
}

// Re-attaches the token. When processErrors is true, append SKIP_ERROR_EMPLOYEES=False; otherwise omit it entirely.
export function applySkipErrorEmployees(remaining: string, processErrors: boolean): string {
  const base = (remaining || "").trim();
  if (!processErrors) return base;
  return base ? `${base};SKIP_ERROR_EMPLOYEES=False` : "SKIP_ERROR_EMPLOYEES=False";
}
